import React from 'react';
import { Toaster } from 'react-hot-toast';
import PropTypes from 'prop-types';

function ToastProvider({ children }) {
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '8px',
            background: '#333',
            color: '#fff',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          },
          success: {
            duration: 5000,
            theme: {
              primary: 'green',
              secondary: 'black',
            },
          },
        }}
      />
      {children}
    </>
  );
}

// Validate props
ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ToastProvider;
